import { FC } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface AdminUserDialogProps {
    open: boolean;
    user: string;
    isAdmin: boolean;
    onAcceptEvent: () => void;
    onDismiss: () => void;
}

const AdminUserDialog: FC<AdminUserDialogProps> = ({ open, onAcceptEvent, onDismiss, user, isAdmin }) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onDismiss}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle>
                {!isAdmin ? t('Promote user to admin') : t('Downgrade user premissions')}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <Typography>
                        {!isAdmin
                            ? t('Do you want to promote {{username}} as an admin?', { username: user })
                            : t('Are you sure you want to downgrade {{username}} to a regular viewer?', {
                                  username: user,
                              })}
                    </Typography>
                    <Typography>
                        {!isAdmin
                            ? t(
                                  'That will allow {{username}} to block other viewers and remove their messages from the chat for all the other viewers',
                                  {
                                      username: user,
                                  },
                              )
                            : t("{{username}} will not be able to block and remove other viewer's messages", {
                                  username: user,
                              })}
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onAcceptEvent}>
                    {!isAdmin ? t('Promote this user') : t('Downgrade this user')}
                </Button>
                <Button onClick={onDismiss} autoFocus>
                    {t('Cancel')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AdminUserDialog;
